import { Col, Row } from 'antd';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCallback, useMemo, useState } from 'react';
import ProfileDetailBox from './ProfileDetailBox';
import PorfileInfo from './PorfileInfo';
import ChangePassword from './ChangePassword';
import ChangePasswordCVV2 from './ChangePasswordCVV2';
import { useUniversityContext, useUserContext } from '@/context';
import { Flex } from '@/components';
import { envConfig } from '@/configs';
import { KeySVG, StudentSVG, KeyDoubleSVG } from '@/components/common/AppIcons';

import './styles.scss';

const ProfilePageDesktop = () => {

  const [t] = useTranslation(['common']);
  const { profile, profileImage } = useUserContext();
  const { university } = useUniversityContext();

  const navigations = useMemo(() => {
    const arr = [
      { scope: 'profile', text: t('common:labels.profile'), icon: <StudentSVG />, content: <PorfileInfo />, serviceKey: null }
    ];
    if (envConfig.isCloud || !envConfig.ui.removeChangePassword) {
      arr.push({
        scope: 'password',
        text: t('common:labels.change-typeof', { value: t('common:labels.password') }),
        icon: <KeySVG />, content: <ChangePassword />,
        serviceKey:
        envConfig.isCloud ? null : (envConfig.ui.removeChangePassword ? 'invalid-key-to-hide' : 'changePassword')
      });
    }
    if (!envConfig.ui.removeCVV2) {
      arr.push({
        scope: 'cvv2',
        text: t('common:labels.change-typeof', { value: t('common:labels.cvv2') }),
        icon: <KeyDoubleSVG />,
        content: <ChangePasswordCVV2 />,
        serviceKey: 'cvv2'
      });
    }
    // if (university.samad.faceEnrollment) {
    //   arr.push({
    //     scope: 'face-enrollment',
    //     text: t('common:labels.authentication'),
    //     icon: <AuthenticateSVG />,
    //     content: <FaceEnrollment />,
    //     serviceKey: 'faceEnrollment'
    //   });
    // }
    return arr;
  }, [university, t]);

  const scope = new URLSearchParams(useLocation().search).get('scope')?.toLowerCase();
  const [current, setCurrent] = useState(scope ?? navigations[0].scope);

  const handleItemClick = useCallback((item: typeof navigations[0]) => {
    setCurrent(item.scope);
  }, []);

  const checkService = useCallback((key: string) => {
    if (!key) return true;
    return university?.samad?.[key];
  }, [university?.samad]);

  return (
    <Row className="app-profile-page">
      <Col xxl={6} xl={8} lg={8} className="app-profile-col">
        <Flex className="app-profile-sidebar" direction="column">
          <Row align="middle">
            <Col span={10} style={{ padding: '1rem' }}>
              <img className="profile-image" src={profileImage} />
            </Col>
            <Col span={12}>
              <Flex className="profile-name" direction="column">
                <span className="text-lg">{profile?.firstName} {profile?.lastName}</span>
                <span>{profile?.student?.studentNumber}</span>
              </Flex>
            </Col>
          </Row>
          <Row>
            <Flex component="ul" className="profile-nav-list">
              {navigations.map((item, index) => (
                checkService(item.serviceKey) ?
                  <li
                    key={index}
                    onClick={handleItemClick.bind(this, item)}
                    className={classNames('nav-list-item', { active: current === item.scope })}>
                    <span className="text-2xl w-[25px] h-[auto] inline-flex items-center">
                      {item.icon}
                    </span>
                    <span>{item.text}</span>
                  </li> : ''
              ))}
            </Flex>
          </Row>
        </Flex>
      </Col>
      <Col xxl={18} xl={16} lg={16}>
        {navigations.map(item => (
          item.scope === current && (
            <ProfileDetailBox title={item.text} key={item.scope}>
              {item.content}
            </ProfileDetailBox>
          )
        ))}
      </Col>
    </Row>
  );
};

export default ProfilePageDesktop;
